module.exports = __webpack_public_path__ + "img/气体管路3.95c577ee.jpg";